import React, { useMemo, useState } from 'react';

const DIA_OPS = [
  { key: 'lu', label: 'Lu' },
  { key: 'ma', label: 'Ma' },
  { key: 'mi', label: 'Mi' },
  { key: 'ju', label: 'Ju' },
  { key: 'vi', label: 'Vi' },
  { key: 'sa', label: 'Sa' },
];

export default function CursadaForm({ onSubmit, onClose, materiasSugeridas = [], defaultRange }) {
  const [materia, setMateria] = useState('');
  const [dias, setDias] = useState([]);
  const [horaInicio, setHoraInicio] = useState('17:00');
  const [horaFin, setHoraFin] = useState('19:00');
  const [desde, setDesde] = useState(() => defaultRange?.desde || new Date().toISOString().slice(0, 10));
  const [hasta, setHasta] = useState(() => defaultRange?.hasta || new Date(Date.now() + 1000 * 60 * 60 * 24 * 90).toISOString().slice(0, 10));
  const [aula, setAula] = useState('');
  const [color, setColor] = useState('');

  const opciones = useMemo(() => {
    const q = materia.toLowerCase();
    return materiasSugeridas.filter((m) => m.toLowerCase().includes(q)).slice(0, 8);
  }, [materia, materiasSugeridas]);

  const isValid = useMemo(() => {
    if (!materia) return false;
    if (!dias.length) return false;
    if (!horaInicio || !horaFin) return false;
    if (!desde || !hasta) return false;
    return horaFin > horaInicio && hasta >= desde;
  }, [materia, dias, horaInicio, horaFin, desde, hasta]);

  function toggleDia(key) {
    setDias((prev) => (prev.includes(key) ? prev.filter((d) => d !== key) : [...prev, key]));
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!isValid) return;
    onSubmit?.({
      id: crypto.randomUUID?.() || String(Date.now()),
      materia,
      dias,
      horaInicio,
      horaFin,
      desde,
      hasta,
      aula: aula || undefined,
      color: color || undefined,
    });
    onClose?.();
  }

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true" onKeyDown={(e) => { if (e.key === 'Escape') onClose?.(); }}>
      <div className="modal">
        <div className="modal-header">
          <div className="card-title">📘 Nueva Cursada</div>
          <button className="icon-btn" aria-label="Cerrar" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit} className="modal-body">
          <div className="field">
            <label htmlFor="cursada-materia">Materia</label>
            <input id="cursada-materia" type="text" value={materia} onChange={(e) => setMateria(e.target.value)} list="materias-cursada" placeholder="Ej: Derecho Civil I" />
            <datalist id="materias-cursada">
              {opciones.map((m) => (
                <option key={m} value={m} />
              ))}
            </datalist>
          </div>
          <div className="field">
            <label>Días</label>
            <div className="chips" role="group" aria-label="Días de cursada">
              {DIA_OPS.map((d) => (
                <button
                  type="button"
                  key={d.key}
                  className={`chip ${dias.includes(d.key) ? 'active' : ''}`}
                  onClick={() => toggleDia(d.key)}
                  aria-pressed={dias.includes(d.key)}
                >
                  {d.label}
                </button>
              ))}
            </div>
          </div>
          <div className="row">
            <div className="field">
              <label htmlFor="cursada-hora-inicio">Hora inicio</label>
              <input id="cursada-hora-inicio" type="time" value={horaInicio} onChange={(e) => setHoraInicio(e.target.value)} />
            </div>
            <div className="field">
              <label htmlFor="cursada-hora-fin">Hora fin</label>
              <input id="cursada-hora-fin" type="time" value={horaFin} onChange={(e) => setHoraFin(e.target.value)} />
            </div>
          </div>
          <div className="row">
            <div className="field">
              <label htmlFor="cursada-desde">Desde</label>
              <input id="cursada-desde" type="date" value={desde} onChange={(e) => setDesde(e.target.value)} />
            </div>
            <div className="field">
              <label htmlFor="cursada-hasta">Hasta</label>
              <input id="cursada-hasta" type="date" value={hasta} onChange={(e) => setHasta(e.target.value)} />
            </div>
          </div>
          <div className="row">
            <div className="field">
              <label htmlFor="cursada-aula">Aula/Comisión (opcional)</label>
              <input id="cursada-aula" type="text" value={aula} onChange={(e) => setAula(e.target.value)} />
            </div>
            <div className="field">
              <label htmlFor="cursada-color">Color (opcional)</label>
              <input id="cursada-color" type="color" value={color || '#60a5fa'} onChange={(e) => setColor(e.target.value)} />
            </div>
          </div>
          <div className="actions">
            <button className="btn-primary" type="submit" disabled={!isValid} aria-label="Guardar cursada">Guardar</button>
          </div>
        </form>
      </div>
    </div>
  );
}


